/* eslint-disable import/no-cycle */
import {
	setMessages,
	setIsLoadingLoadedMessages,
	setHasLoadingError,
	deleteMessage,
	deleteMessages,
} from './actions';
import { ROOT_SLICE } from './constants';
import {
	selectRootSlice,
	selectIsLoadingMessages,
	selectIsLoadedMessages,
	selectHasLoadingError,
	selectMessages
} from './selectors';

const isDefined = v => v !== undefined && v !== null;

// ************
// PARTS
// ************
const reducerParts = {
	[setMessages]: (state, { payload: { messages } }) => {
		const rootSlice = selectRootSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, messages }
		};
	},

	[setHasLoadingError]: (state, { payload: { hasError } }) => {
		const rootSlice = selectRootSlice(state);
		const currentHasError = selectHasLoadingError(state);

		if (hasError === currentHasError) {
			return state;
		}

		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				hasLoadingErrorMessages: hasError
			}
		};
	},

	[setIsLoadingLoadedMessages]: (
		state,
		{
			payload: {
				isLoadingMessages: newIsLoadingMessages,
				isLoadedMessages: newIsLoadedMessages
			}
		}
	) => {
		const rootSlice = selectRootSlice(state);
		const isLoadingMessages = selectIsLoadingMessages(state);
		const isLoadedMessages = selectIsLoadedMessages(state);

		const isLoadingChanged =
			isDefined(newIsLoadingMessages) &&
			newIsLoadingMessages !== isLoadingMessages;
		const isLoadedChanged =
			isDefined(newIsLoadedMessages) &&
			newIsLoadedMessages !== isLoadedMessages;

		if (!isLoadingChanged && !isLoadedChanged) {
			return state;
		}

		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				isLoadingMessages: isLoadingChanged
					? newIsLoadingMessages
					: isLoadingMessages,
				isLoadedMessages: isLoadedChanged
					? newIsLoadedMessages
					: isLoadedMessages
			}
		};
	},

	[deleteMessage]: (state, { payload: { message } }) => {
		const rootSlice = selectRootSlice(state);
		const messages = selectMessages(state) || [];
		const newMessages = messages.filter(m => m.uuid !== message?.uuid);

		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				messages: newMessages
			},
		};
	},

	[deleteMessages]: (state, { payload: { messages: messagesToDelete } }) => {
		const rootSlice = selectRootSlice(state);
		const messages = selectMessages(state) || [];
		const newMessages = messages.filter(m => (messagesToDelete.findIndex(m2d => m?.uuid === m2d?.uuid) === -1));

		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				messages: newMessages
			},
		}; 
	}
};

export default reducerParts;
